// 多单活动奖励
import { post } from '../axios'

// 分页查询
export function queryPageActivities(map) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/share/activity/list`,
    map
  )
}
// 保存编辑
export function savePageActivities(map) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/share/activity/upsert`,
    map
  )
}
//生成链接
export function genUrlPageActivities(map) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/share/activity/genUrl`,
    map
  )
}
//详情
export function detailPageActivities(map) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/share/activity/detail`,
    map
  )
}
